import {useParams} from 'react-router-dom'
import {useRoleUser} from './useRoleUser'
import {ORDER_STATUS} from 'src/constants'

type TSIP = 'all' | 'new-order' | 'reject' | 'outstanding' | 'finish'

/**
 * Hook ini menampilkan daftar status untuk order berdasarkan
 * tipe SIP ['all'|'reject'|'new'|'outstanding'|'finish'] dan role user.
 * Untuk mengambil tipenya menggunakan useParam dari react-router-dom
 */
export const useOrderStatus = () => {
  const {isSalesAnper, isSalesAdmin, isCustomer} = useRoleUser()
  const params = useParams<{type: TSIP}>()

  const isAll = params.type === 'all' || params.type === undefined
  const isReject = params.type === 'reject'
  const isNew = params.type === 'new-order'
  const isOutstanding = params.type === 'outstanding'
  const isFinish = params.type === 'finish'
  console.log("statuses", ORDER_STATUS)

  /**
   * Jika role user "PI atau Customer" dan param type-nya "new" maka statusnya adalah:
   * - Dikirimkan (0)
   * - Ditinjau (1)
   * - Revisi (2)
   * - Proses Negosiasi (3)
   * - Negosiasi Diterima (6)
   */
  if ((isSalesAdmin && isNew) || (isCustomer && isNew)) {
    return ORDER_STATUS.filter(
      (item) =>
        item.value === '0' ||
        item.value === '1' ||
        item.value === '2' ||
        item.value === '3' ||
        item.value === '6' ||
        (isSalesAdmin && item.value === '7') ||
        item.value === '91'
    )
  }

  /**
   * TODO: Jika role user "ANPER" dan param type-nya "new" maka statusnya adalah:
   * - Realisasi yang kontraknya belum terbit
   */
  if (isSalesAnper && isNew) {
    return ORDER_STATUS.filter((item) => item.value === '9')
  }

  /**
   * Jika role user "PI atau Customer" dan param type-nya "reject" maka statusnya adalah:
   * - Ditolak (90)
   */
  if ((isSalesAdmin && isNew) || (isCustomer && isNew)) {
    return ORDER_STATUS.filter((item) => item.value === '90')
  }

  /**
   * Jika role user "ANPER" dan param type-nya "reject" maka statusnya adalah:
   * - tidak ditampilkan
   */
  if (isSalesAnper && isReject) {
    return []
  }

  /**
   * Jika role user "Pi atau Customer" dan param type-nya "outstanding" maka statusnya adalah:
   * - Realisasi (4)
   */
  if ((isSalesAdmin && isOutstanding) || (isCustomer && isOutstanding)) {
    return ORDER_STATUS.filter((item) => {
      return item.value === '4' ||
      (isSalesAdmin && item.value === '9') ||
      item.value === '10' ||
      (isSalesAdmin && item.value === '11')
    })
  }

  /**
   * TODO: Jika role user "ANPER" dan param type-nya "outstanding" maka statusnya adalah:
   * - Realisasi yang kontraknya sudah terbit
   */
  if (isSalesAnper && isOutstanding) {
    return ORDER_STATUS.filter((item) => item.value === '10' || item.value === '11')
  }

  /**
   * Jika role user "PI atau Customer" dan param type-nya "finish" maka statusnya adalah:
   * - Selesai (5)
   */
  if ((isSalesAdmin && isFinish) || (isCustomer && isFinish) || (isSalesAnper && isFinish)) {
    return ORDER_STATUS.filter((item) => item.value === '5')
  }

  /**
   * Jika role user "PI atau Customer" dan param type-nya "all" maka statusnya adalah:
   * - semua status
   */
  if ((isSalesAdmin && isAll) || (isCustomer && isAll)) {
    return ORDER_STATUS
  }

  /**
   * Jika role user "Anper" dan param type-nya "all" maka statusnya adalah:
   * - Realisasi (4)
   * - Selesai (5)
   */
  if (isSalesAnper && isAll) {
    return ORDER_STATUS.filter((item) => item.value === '4' || item.value === '5')
  }

  return ORDER_STATUS
}
